import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';

import {Componente} from '../app/interfaces/interfaces';
import {forkJoin, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  constructor(private http: HttpClient) { }

  getMenuOptions() {
    return this.http.get<Componente[]>('/assets/data/menu.json');
  }

  onHttpError = (error: HttpErrorResponse) => {
    // Do common error tasks (logging, registering, configuration...)
    console.log('Error en la respuesta');
  }
  // pasarla linea
  getStations(linea): Observable<any[]> {
    /*
      return this.http.get('https://tmbapi.tmb.cat/v1/metro/trains/arrivals/routes/1/' +
          'stops/114?app_id=e8e58d40&app_key=a87e2200fd63a67db4492d0ddde2db6a&timestamp=1561452442715');
      */
    const get = this.http.get<any[]>('https://tmbapi.tmb.cat/v1/metro/trains/routes/' + linea + '/' +
        'stops?app_id=e8e58d40&app_key=a87e2200fd63a67db4492d0ddde2db6a&timestamp=1561566951971');
    // tslint:disable-next-line: deprecation
    get.subscribe(null, this.onHttpError);
    return get;

  }

  // pasar por parametro linea y estacion
  getTrains(linea, estacion): Observable<any[]> {
    return this.http.get<any[]>('https://tmbapi.tmb.cat/v1/metro/trains/arrivals/routes/' + linea + '/' +
        'stops/' + estacion + '?app_id=e8e58d40&app_key=a87e2200fd63a67db4492d0ddde2db6a&timestamp=1561452442715');

  }

  getEventsTrains(linea, estacion, estacion2) {

    // tslint:disable-next-line: deprecation
    return forkJoin(
        this.getTrains(linea, estacion),
        this.getTrains(linea, estacion2)
    ).pipe(map(([primero, segundo]) => {
      return {primero, segundo};
    }));
  }
}
